module.exports = "/images/SS.webp?975bb50185b6ea171e4798fd32d6d041";